module.exports = __webpack_public_path__ + "step5.c2ff6f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/old steps/step5.png
// module id = PIDA
// module chunks = 0